import(/* webpackMode: "eager", webpackExports: ["CalendarDialogWrapper"] */ "/vercel/path0/components/calendar/CalendarDialogWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/calendar/CalendarTools.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/calendar/CalendarView.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["CurrentTimeIndicator"] */ "/vercel/path0/components/calendar/CurrentTimeIndicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceColumn"] */ "/vercel/path0/components/calendar/ResourceColumn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceCombo"] */ "/vercel/path0/components/calendar/ResourceCombo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceGrid"] */ "/vercel/path0/components/calendar/ResourceGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceSelectorDropdown"] */ "/vercel/path0/components/calendar/ResourceSelectorDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientEventIntervalRefetcher"] */ "/vercel/path0/components/ClientEventIntervalRefetcher.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
